
import React, { useState, useEffect,  useContext , useRef } from "react";
import BoostTitle from "../Home Section/figma/BoostTitle";
import QuickerResponse from "../Home Section/figma/QuickerResponse";
import IndustriesAll from "../Home Section/figma/IndustriesAll";
import Features from "../Home Section/figma/Features";
import FAQ from "../Home Section/figma/FAQ";
import GetStartedNow from "../Home Section/figma/GetStartedNow";
import Footer from "../Home Section/figma/Footer";
import Navbar from "../Home Section/figma/Navbar";
import Pricing from "../Home Section/figma/Pricing";
import MyContext from "../../../MyContext";
import { ToastContainer, toast } from "react-toastify";
import GoogleOneTap from "../../Googleonetab";
import ChatBotHome from "./ChatBotHome";

function Home_page () {

  const { baseUrl } = useContext(MyContext)
   const hasAutoOpened = useRef(false);
   const { openFreeTrialModal } = useContext(MyContext);

     const registerUserAfterGoogleLogin = async (googleUser) => {
    // console.log(" register API CALLED", googleUser);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.email,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    // console.log(" REGISTER PAYLOAD", payload);

    const response = await fetch(`${baseUrl}/api/User/register`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }

      sessionStorage.setItem("user", JSON.stringify(registerResult.response));

      sessionStorage.setItem("power", "1");

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1500);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("accessToken");

    if (!isLoggedIn && !hasAutoOpened.current) {
      hasAutoOpened.current = true;

      const timer = setTimeout(() => {
        openFreeTrialModal();
      }, 0); 

      return () => clearTimeout(timer);
    }
  }, [openFreeTrialModal]);
  return (
    <>
    <ToastContainer />

      <Navbar/>
      <BoostTitle />
      <QuickerResponse/>
      <IndustriesAll/>
      <Features/>
      <Pricing/>
      <FAQ/>
      <GetStartedNow/>
      <ChatBotHome/>
      <Footer/>

       {!sessionStorage.getItem("user") && (
              <GoogleOneTap onSuccess={handleGoogleResponse} />
            )}
    </>
  );
}

export default Home_page;
